export default __webpack_public_path__ + "static/media/FuturaTOT-ExtrBold.3b230403.otf";